module.exports = __webpack_public_path__ + "static/media/actorbg.791d2109.png";